const dashboardConstants = {}
dashboardConstants.GET_GRAPHS_PRODUCTIVITY = 'graphs/productivity'
dashboardConstants.GET_GRAPHS_ALLOCATED_STATICS = 'graphs/allocated-statistics'
dashboardConstants.GET_UNLOCATED_GRAPH = 'graphs/unallocated'
dashboardConstants.GET_USER_STATS = 'v2/charts/user-stats'

export default dashboardConstants